import * as React from 'react';
import omit from 'lodash/omit';
import classNames from 'classnames';
import Element from './Element';
import ConfigContext from '../config-provider/ConfigContext';
const SkeletonAvatar = function SkeletonAvatar(props) {
    const { prefixCls: customizePrefixCls, className, active } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const cls = classNames(prefixCls, className, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
    });
    return (React.createElement("div", { className: cls },
        React.createElement(Element, Object.assign({ prefixCls: `${prefixCls}-avatar` }, omit(props, ['prefixCls'])))));
};
SkeletonAvatar.displayName = 'SkeletonAvatar';
SkeletonAvatar.defaultProps = {
    size: 'default',
    shape: 'circle',
};
export default React.memo(SkeletonAvatar);
